import { Button, Form, Row, Space, Spin, Table, Tabs, TabsProps } from "antd";
import { InputFields, Notification } from "components/common";
import React, { useEffect, useRef, useState } from "react";
import { columnsTable, columnsTable2, columnsTable3, fields } from "./config";
import { FORMAT_TIME, tabKeys } from "types/enums";
import ChartWatingTime from "./components/ChartWatingTime";
import ChartExamationtime from "./components/ChartExamationtime";
import ChartQuantityPatient from "./components/ChartQuantityPatient";
import dayjs from "dayjs";
import { ExcelSVG, EyeWhiteSVG } from "assets";
import { examinationService } from "api";

const Chart = () => {
  const [form] = Form.useForm();
  const [totalPage, setTotalPage] = useState();

  const [loading, setLoading] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
  });

  const [dataChart, setDataChart] = useState<any>([]);
  const [childTab, setChieldTab] = useState(tabKeys.EXAMINATION.CHART_WATTING);
  const nam = Form.useWatch("year", form);
  const paginationConfig = {
    current: params.page,
    total: totalPage,
    showSizeChanger: true,
    pageSize: params.limit,
    onChange: handlePaginationChange,
  };
  function handlePaginationChange(page, pageSize) {
    setParams({
      ...params,
      page: page,
      limit: pageSize,
    });
  }
  useEffect(() => {
    setParams({
        ...params,
        page: 1, // Reset page to 1 when the active tab changes
    });
}, [childTab]); // Run this effect whenever childTab changes
  columnsTable.find((el) => el.dataIndex === "stt").render = (v, r, i) =>
    (params.page - 1) * params.limit + i + 1;
  columnsTable2.find((el) => el.dataIndex === "stt").render = (v, r, i) =>
    (params.page - 1) * params.limit + i + 1;
  columnsTable3.find((el) => el.dataIndex === "stt").render = (v, r, i) =>
    (params.page - 1) * params.limit + i + 1;
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.EXAMINATION.CHART_WATTING,
      label: `Thời gian chờ ở từng khu vực`,
      children: (
        <>
          <ChartWatingTime dataChart={dataChart.map} nam={nam} />
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={dataChart.datas}
            columns={columnsTable}
            scroll={{ x: 2000 }}
          />
        </>
      ),
    },
    {
      key: tabKeys.EXAMINATION.CHART_EXAMATION,
      label: `Thời gian khám ở từng khu vực`,
      children: (
        <>
          <ChartExamationtime dataChart={dataChart.map} nam={nam} />,
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={dataChart.datas}
            columns={columnsTable2}
            scroll={{ x: 2000 }}
          />
        </>
      ),
    },
    {
      key: tabKeys.EXAMINATION.CHART_QUANTITY_PATIENT,
      label: `Số lượng bệnh nhân phải chờ và khám ở mỗi khu vực trên 90 phút`,
      children: (
        <>
          <ChartQuantityPatient dataChart={dataChart.map} nam={nam} />,
          <Table
            bordered
            pagination={paginationConfig}
            dataSource={dataChart.datas}
            columns={columnsTable3}
            scroll={{ x: 2000 }}
          />
        </>
      ),
    },
  ];

  const handleOnSearch = async () => {
    const data = await form.validateFields();

    getDataChart(data);
  };

  const getDataChart = async (params) => {
    setLoading(true);

    try {
      if (childTab === tabKeys.EXAMINATION.CHART_WATTING) {
        const res = await examinationService.getChart({
          ...params,
          type: 0,
        });

        setDataChart(res);
      } else if (childTab === tabKeys.EXAMINATION.CHART_EXAMATION) {
        const res = await examinationService.getChart({
          ...params,
          type: 1,
        });
        setDataChart(res);
      } else {
        const res = await examinationService.getChart({
          ...params,
          type: 2,
        });
        setDataChart(res);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handelOnExport = async () => {
    const data = await form.validateFields();
    let label = '';
    if (childTab === tabKeys.EXAMINATION.CHART_WATTING) {
        label = 'thời gian chờ ở từng khu vực';
    } else if (childTab === tabKeys.EXAMINATION.CHART_EXAMATION) {
        label = 'thời gian khám ở từng khu vực';
    } else {
        label = 'số lượng bệnh nhân phải chờ và khám ở mỗi khu vực trên 90 phút';
    }

    try {
      const response = await examinationService.getExportChart({
       ...data,
        type: childTab === tabKeys.EXAMINATION.CHART_WATTING? 0 : childTab === tabKeys.EXAMINATION.CHART_EXAMATION? 1 : 2,
      });
      var link = document.createElement("a");
      const url = window.URL.createObjectURL(response.data);
      link.href = url;
      link.download = `Báo cáo ${label}.xlsx`; // Use the label here
      link.click();
      Notification("success", "Đã xuất file báo cáo");
    } catch (error) {
      Notification("error", "Đã có lỗi xảy ra khi xuất file báo cáo");
    }
  };
  const handleChangeTab = (e: any) => {
    setDataChart([]);
   // form.resetFields();
    setChieldTab(e);
  };
  return (
    <Spin spinning={loading}>
      <div className="container">
        <Space style={{ width: "100%" }} direction="vertical">
          <Form form={form}>
            <Row gutter={[16, 8]}>
              <InputFields data={fields} />
            </Row>
          </Form>
          <Row justify={"end"} style={{ gap: 5 }}>
            <Button
              icon={<ExcelSVG />}
              className="custom-btn"
              onClick={handelOnExport}
            >
              Xuất báo cáo
            </Button>
            <Button
              htmlType="submit"
              onClick={handleOnSearch}
              type="ghost"
              className="btn-sub"
              icon={<EyeWhiteSVG />}
            >
              Xem chi tiết
            </Button>
          </Row>
        </Space>
      </div>
      <div className="container">
        <Tabs items={itemsInit} onChange={(e) => handleChangeTab(e)} />
      </div>
    </Spin>
  );
};

export default Chart;
